import allytm from '@ally/allytm'
import { Link as MUILink } from '@ally/metronome-ui'
import React, { FC, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useHostServices } from '../HostServices'
import { getTransferTicket } from '../utils/transferTicket'
import { Loader } from './Loader'
import { Error } from './Error'

function getDestinationURL(ticketID?: string): string {
  const { pathname, searchParams } = new URL(window.location.toString())
  if (ticketID) searchParams.append('ticketID', ticketID)
  const destination = pathname.replace(/^\/sso\/ola\//, '/ext-ola/')
  return `${destination}?${searchParams.toString()}`
}

export const OLA: FC = () => {
  const {
    transmitRef,
    session,
    log: { track },
  } = useHostServices()

  const [failed, setFailed] = useState<boolean>(false)

  useEffect(() => {
    track('ally-next-remote-sso-ola-init')
    // "Page View" Analytics
    allytm.event('pageview', 'AOS:Dashboard:OLA Interstitial')

    const fetcher = getTransferTicket(transmitRef, session.data, 'invest')

    fetcher
      .then(ticketID => {
        const destination = getDestinationURL(ticketID)
        track('ally-next-remote-sso-ola-done')
        window.location.replace(destination)
      })
      .catch(() => {
        track('ally-next-remote-sso-ola-error')
        setFailed(true)
      })
  }, [])

  // Error Analytics
  useEffect(() => {
    if (failed)
      allytm.event('customError', 'Were Having Trouble Redirecting You')
  }, [failed])

  return (
    <>
      <Loader description="We're taking you to the Ally Invest online application." />
      {failed && (
        <Error
          errorMessage={
            <>
              We&apos;re having trouble redirecting you. We&apos;re working on a
              fix, so try again in a bit.{' '}
              <MUILink
                variant="link"
                text="Return to Snapshot"
                allytmln="returnToSnapshot"
              >
                <Link to="/dashboard" />
              </MUILink>
            </>
          }
        />
      )}
    </>
  )
}
